import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { TIRE_SEARCH_COLUMNS } from "./consts";
import { WarehouseSearchResultsProps } from "./types";
import { useTranslate } from "helpers";


const WarehouseSearchResults: React.FC<WarehouseSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={TIRE_SEARCH_COLUMNS(t)}
        data={searchResults.data}
        selectableRows={false}
        selectedRows={selectedRows}
        showSelectAll={false}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }

        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(WarehouseSearchResults);
